import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import 'react-table/react-table.css';
import { getNoteGroupDropDown, getFieldNoteById, getNoteDocument, getNoteReport, setInitialState, deleteNote } from '../../actions/note/NotesActions';
import DatePickerForFilter from '../../utils/DatePickerForFilter';
import i18n from '../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import { Button } from '@material-ui/core';
// import { withStyles } from '@material-ui/core/styles';
import { exportDocument } from '../../actions/ExportActions';
import { Export } from '../../utils/Export';
import DashboardDrawer from '../../utils/DashboardDrawer';
import AddNote from './AddNote';
import axios from '../../utils/AxiosWrapper';
import { Delete } from '../../utils/Delete';
// ===========================================
import css from './Note.module.css';
// import { commonHeaderStyle } from '../../utils/GlobalStyles';
import Tooltip2 from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import SearchBar from 'material-ui-search-bar';
import * as Icons from '@material-ui/icons';
import { PulseLoader } from 'react-spinners';
import { withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { filter } from 'lodash';
import { toast } from 'react-toastify';


const CheckboxTable = checkboxHOC(ReactTable);;


const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '8px 6px',
    backgroundColor: '#04764e',
    color: "#fff",
    fontSize: 13,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
};

const styles = theme => ({
    primaryMain: { backgroundColor: theme.palette.primary.main },
    paginationButton: {
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#5EB3E4',
        color: 'white',
        border: 'none',
        cursor: 'pointer'
    },
    addActionBtn: {
        minWidth: 90,
        height: 32,
        borderRadius: 6,
        padding: '0 12px',
        fontSize: 12,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
    },
    iconWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    actionIcon: {
        color: '#4a4a4a'
    },
    filtersSection: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
        paddingLeft: '30px',
        paddingTop: '18px',
    },
    dropDowns: {
        backgroundColor: '#F4F6F7',
        color: '#333333', fontSize: '14px',
        border: 'none',
        borderBottom: '1px solid #333333',
        marginRight: '20px',
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '4px', '&:focus':
        {
            outline: 'none',
            boxShadow: '0 0 0 2px #333333',
        },
        '&:hover': { backgroundColor: '#E2E5E7', },
        '& option':
        {
            backgroundColor: '#FFFFFF',
            color: '#333333',
            fontSize: '14px',
        }
    },
    resetButton: {
        background: 'linear-gradient(90deg, #E6E9EC, #D1D6D8)', // Lighter gray gradient
        color: '#333333',
        fontSize: '14px',
        fontWeight: 'normal',
        border: 'none',
        padding: '8px 12px',
        // margin: '0 0 0 20px !important',
        borderRadius: '4px', // Matches dropdown shape
        cursor: 'pointer',
        transition: 'background 0.3s ease', // Smooth hover transition
        borderBottom: '1px solid #333333', // Underline like dropdown
        '&:hover': {
            background: 'linear-gradient(90deg, #E2E5E7, #D5D8DA)', // Matching hover gradient with a darker tone
        },
        '&:active': {
            background: 'linear-gradient(90deg, #D5D8DA, #C7CACD)', // Slightly darker gradient for active state
        },
        '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 2px #333333', // Optional: subtle focus indicator
        },
    },
    numberInput: {
        margin: '0 20px 0 0'
    }
});




export class Note extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            selection: [],
            selectAll: false,
            add: false,
            edit: false,
            delete: false,

            // ====================

            allNotes: [],
            filteredNotes: [],
            searchBarValue: '',
            loading: false,
            addNewNote: false,
            deleteWindow: false,
            editWindow: false,
            idForDeletion: null,
            itemForEdit: null,
            previewWindow: false,
            itemForPreview: null,
            allNoteTypes: [],
            selectedNoteType: '',
            fieldSearchValue: '',
            selectedField: ''
        };
        this.tableScrollTop = 0;
    }

    componentDidMount() {
        this.fetchAllNotes();
        console.log("this.props.noteReport :::", this.props.noteReport)


        localStorage.removeItem('row');
        if (this.props.noteGroupDropDown.length === 0) {
            this.props.getNoteGroupDropDown();
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getNoteReport(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');

        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { notesPostingSuccess, noteGroupDropDown } = this.props;

        if (prevProps.notesPostingSuccess === false && notesPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getNoteReport(wrapped.state);
            this.props.setInitialState('notesPostingSuccess');
        }

        if (prevProps.noteGroupDropDown !== noteGroupDropDown) {
            console.log("noteGroupDropDown ::: ", noteGroupDropDown)
            if (this.props.userProfile.id_jezik === 1) {
                this.setState({
                    noteGroupDropDown: immutable.asMutable(noteGroupDropDown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
                })
            }
            else if (this.props.userProfile.id_jezik === 2) {
                this.setState({
                    noteGroupDropDown: immutable.asMutable(noteGroupDropDown.map((item) => { return { label: item.naziv_en, value: item.id } }), { deep: true }),
                })
            } else if (this.props.userProfile.id_jezik === 4) {
                this.setState({
                    noteGroupDropDown: immutable.asMutable(noteGroupDropDown.map((item) => { return { label: item.naziv_hr, value: item.id } }), { deep: true }),
                })
            }
        }

        if (prevState.searchBarValue !== this.state.searchBarValue || prevState.selectedNoteType !== this.state.selectedNoteType || prevState.selectedField !== this.state.selectedField) {
            this.applyFilters();
        }

    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
            this.props.setInitialState('notesObj');
        } else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.props.setInitialState('notesObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    selectAll: false,
                })
            }
        });
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteNote(this.state.selection);
        this.setState({ delete: false });
    }

    onEditClick = () => {
        const { getFieldNoteById, getNoteDocument } = this.props;
        const { selection } = this.state;
        getFieldNoteById(selection);
        this.setState({ add: !this.state.add, edit: true }, () => {
            // getNoteDocument(selection)
        });
    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    onExportClick = () => {
        this.setState({ export: !this.state.export });
    }

    exportFunction = () => {
        const table = this.checkboxTable.getWrappedInstance();
        console.log('fnnn ttt', table)
        this.props.exportDocument(this.state.docTitle, table.state, 'api/report/field_note');
        this.setState({ export: !this.state.export });
    }

    onPieClick = () => {
        this.props.history.push('/notes_dashboard');
    }

    onTableClick = () => {
        this.props.history.push('/notes');
    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    // =========================================
    fetchAllNotes = () => {
        this.setState({ loading: true });
        axios.get('api/report/field_note')
            .then((response) => {
                console.log('notes report response ::: ', response)
                this.setState({ allNotes: response.data, filteredNotes: response.data }, () => {
                    this.populateDropDowns();
                    console.log("this.state.allNotes IGOR ::: ", this.state.allNotes)
                });
            })
            .catch((error) => {
                console.log('notes report error ::: ', error)
            })
            .finally(() => { this.setState({ loading: false }) })
    }

    populateDropDowns = () => {

        const uniqueMap = new Map();
        this.state.allNotes.forEach(note => {
            const naziv = i18n.t(`${note.naziv_en} *`);
            if (!uniqueMap.has(naziv)) {
                uniqueMap.set(naziv, { naziv, naziv_en: note.naziv_en });
            }
        });
        this.setState({
            allNoteTypes: Array.from(uniqueMap.values())
        }, () => { console.log("allNoteTypes ::: ", this.state.allNoteTypes) })
    }



    applyFilters = () => {
        this.setState({
            filteredNotes: this.state.allNotes
                .filter(note => note.naslov.toLowerCase().includes(this.state.searchBarValue.toLowerCase()))
                .filter(note => this.state.selectedNoteType === '' || note.naziv_en === this.state.selectedNoteType)
                .filter(note => this.state.selectedField === '' || (note.tabla_naziv && note.tabla_naziv.toLowerCase().includes(this.state.selectedField.toLowerCase())))
        });
    }

    resetMyFilters = () => {
        this.setState({
            searchBarValue: '',
            selectedNoteType: '',
            selectedField: '',
        });
    }

    handleCloseAddNewNote = () => {
        this.setState({ addNewNote: false }, () => {
            this.fetchAllNotes();
        });
    }

    handleCloseEditWindow = () => {
        this.setState({ editWindow: false, itemForEdit: null }, () => {
            this.fetchAllNotes();
        });
    }

    deleteOneNote = () => {
        axios.post(`api/note/delete`, { selection: [this.state.idForDeletion] })
            .then(() => {
                toast.success(i18n.t('Note successfully deleted!'), {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    draggablePercent: 80,

                })

            })
            .catch(() => {
                toast.error(i18n.t('Error deleting note!'), {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    draggablePercent: 80,
                });
            })
            .finally(() => {
                this.setState({ deleteWindow: false, idForDeletion: null });
                this.fetchAllNotes();
            });

    }

    handleCloseDeleteWindow = () => {
        this.setState({ deleteWindow: false, idForDeletion: null });
        this.fetchAllNotes();
    }

    handleClosePreviewWindow = () => {
        this.setState({ previewWindow: false, itemForPreview: null });
    }

    hasValidCoordinates = (item) => {
        const x = Number(item && item.x);
        const y = Number(item && item.y);
        return Number.isFinite(x) && Number.isFinite(y);
    }

    handleMapClick = (item) => {
        if (!this.hasValidCoordinates(item)) return;

        const fieldId = Number(item && item.id_tabla);
        const rawNoteSeasonId = item && item.id_sezona;
        const noteSeasonId = (rawNoteSeasonId === null || rawNoteSeasonId === undefined || rawNoteSeasonId === '')
            ? NaN
            : Number(rawNoteSeasonId);
        const rawDefaultSeasonId = this.props.userProfile && this.props.userProfile.id_default_sezona;
        const defaultSeasonId = (rawDefaultSeasonId === null || rawDefaultSeasonId === undefined || rawDefaultSeasonId === '')
            ? NaN
            : Number(rawDefaultSeasonId);
        const fieldLabel = item.tabla_naziv || item.naziv || (Number.isFinite(fieldId) ? String(fieldId) : '');

        const row = {
            id: Number.isFinite(fieldId) ? fieldId : null,
            naziv: fieldLabel,
            id_sezona: (Number.isFinite(noteSeasonId) && noteSeasonId > 0)
                ? noteSeasonId
                : ((Number.isFinite(defaultSeasonId) && defaultSeasonId > 0) ? defaultSeasonId : null),
            label_sezona: '',
            x: Number(item.x),
            y: Number(item.y)
        };

        localStorage.setItem('row', JSON.stringify(row));
        this.props.history.push('/maps');
    }



    render() {
        const columns = [
            {
                Header: i18n.t('Title'),
                accessor: 'naslov',
            },
            {
                Header: i18n.t('Date of the event'),
                accessor: 'datum_dogadjaja',
                Filter: ({ filter, onChange }) =>
                    <DatePickerForFilter
                        onChange={({ startDate, endDate }) => {
                            onChange({ startDate, endDate });
                        }}

                    />
            },
            {
                Header: i18n.t('Notes type'),
                accessor: 'naziv',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.noteGroupDropDown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />

            },
            {
                Header: i18n.t('Name'),
                accessor: 'ime',
            },
            {
                Header: i18n.t('Surname'),
                accessor: 'prezime',
            },
            {
                Header: i18n.t('Description'),
                accessor: 'opis',
            }

        ];

        if (this.props.userProfile.id_jezik === 1) {
            columns[2].accessor = 'naziv';
        }
        if (this.props.userProfile.id_jezik === 4) {
            columns[2].accessor = 'naziv_hr';
        }

        const { toggleSelection, toggleAll, isSelected, handleClick } = this;
        const { selectAll, add, edit } = this.state;
        const { theme } = this.props;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit", fontSize: '13px', lineHeight: '20px', height: '32.8px' } };
                }
                return { style: { height: '32.8px' } };
            },
            getTheadFilterProps: () => {
                return {
                    style: {
                        backgroundColor: '#3E9571'
                    }
                };
            },
            getTheadTrProps: () => {
                return {
                    style: {
                        backgroundColor: theme.palette.secondary.main,
                        color: '#FFFFFF'
                    }
                };
            },
        };

        // ======================================================

        const { classes } = this.props;

        const columns2 = [
            {
                Header: i18n.t('Title'),
                accessor: 'naslov',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Date of the event'),
                accessor: 'datum_dogadjaja',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Notes type'),
                accessor: 'naziv_en',
                headerStyle: commonHeaderStyle,
                Cell: cell => (cell && cell.value) ? i18n.t(`${cell.value} *`) : ''
            },
            {
                Header: i18n.t('Name and surname'),
                accessor: 'ime',
                headerStyle: commonHeaderStyle
            },
            // {
            //     Header: i18n.t('Surname'),
            //     accessor: 'prezime',
            //     headerStyle: commonHeaderStyle
            // },
            {
                Header: i18n.t('Field'),
                accessor: 'tabla_naziv',
                headerStyle: commonHeaderStyle
            },
            // {
            //     Header: i18n.t('GPS provider'),
            //     accessor: 'gps_provajder_naziv',
            //     headerStyle: commonHeaderStyle
            // },
            // {
            //     Header: i18n.t('GPS device number'),
            //     accessor: 'gps_broj_uredjaja',
            //     headerStyle: commonHeaderStyle
            // },
            {
                width: 90,
                Header: i18n.t('Description'),
                accessor: 'opis',
                // sortable: false,
                // filterable: false,
                headerStyle: commonHeaderStyle,
                // Cell: cell => {
                //     const owned = !!cell.row._original.id_pogonska_masina_klijent;
                //     const selected = { ...cell.row._original, id_pogonska_masina: cell.row._original.id };
                //     return (
                //         <div className={classes.iconWrapper}>
                //             <Button
                //                 variant="contained"
                //                 size="small"
                //                 disabled={owned}
                //                 className={css.addActionBtn}
                //                 style={owned ? { backgroundColor: '#058457', color: '#fff' } : { backgroundColor: '#58B4E5', color: '#fff' }}
                //                 onClick={() => this.handleOpenNewMachine(selected, false)}
                //             >
                //                 {!owned && <AddIcon style={{ fontSize: 16, color: '#fff' }} />}
                //                 {owned ? <Icons.Check style={{ fontSize: 16, color: '#fff' }} /> : i18n.t('Add')}
                //             </Button>
                //         </div>
                //     );
                // }
            },
            {
                width: 80,
                Header: i18n.t('Map'),
                accessor: 'mapa',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    const canOpenMap = this.hasValidCoordinates(cell.row._original);
                    return (
                        <div className={classes.iconWrapper}>
                            <Tooltip2 title={i18n.t('Map')}>
                                <span>
                                    <IconButton
                                        aria-label="Map"
                                        disabled={!canOpenMap}
                                        style={!canOpenMap ? { opacity: 0.45 } : {}}
                                        onClick={() => this.handleMapClick(cell.row._original)}
                                    >
                                        <Icons.Map
                                            fontSize="default"
                                            style={!canOpenMap ? { color: '#b8b8b8' } : {}}
                                        />
                                    </IconButton>
                                </span>
                            </Tooltip2>
                        </div>
                    );
                }
            },
            {
                width: 80,
                Header: i18n.t('Preview'),
                accessor: 'pregled',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    // const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    // if (!owned) return null;
                    const selected = {
                        ...cell.row._original,
                        id: cell.row._original.id_pogonska_masina_klijent,
                        base_machine_id: cell.row._original.base_machine_id || cell.row._original.id
                    };
                    return (
                        <div className={classes.iconWrapper}>
                            < Tooltip2 title={i18n.t("Preview")} >
                                <IconButton aria-label="preview"
                                    color="secondary"
                                    onClick={() => {
                                        this.setState({ itemForPreview: cell.original }, () => {
                                            this.setState({ previewWindow: true })
                                        })
                                    }}>
                                    <Icons.Visibility fontSize="large" />
                                </IconButton>
                            </Tooltip2 >

                        </div>
                    );
                }
            },
            {
                width: 80,
                Header: i18n.t('Edit'),
                accessor: 'izmena',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    // const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    // if (!owned) return null;
                    const selected = {
                        ...cell.row._original,
                        id: cell.row._original.id_pogonska_masina_klijent,
                        base_machine_id: cell.row._original.base_machine_id || cell.row._original.id
                    };
                    return (
                        <div className={classes.iconWrapper}>
                            <Tooltip2 title={i18n.t("Edit")}>
                                <IconButton aria-label="edit" onClick={() => {

                                    this.setState({ itemForEdit: cell.original }, () => {
                                        console.log("This.state.itemForEdit ::: ", this.state.itemForEdit)
                                        this.setState({ editWindow: true })
                                    })
                                }}>
                                    <Icons.Edit className={classes.actionIcon} fontSize="default" />
                                </IconButton>
                            </Tooltip2>
                        </div>
                    );
                }
            },
            {
                width: 80,
                Header: i18n.t('Delete'),
                accessor: 'detalji',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    // const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    // if (!owned) return null;
                    return (
                        <div className={classes.iconWrapper}>
                            <Tooltip2 title={i18n.t("Delete")}>
                                <IconButton aria-label="Delete"
                                    onClick={() => {
                                        console.log('Delete note CELL :::', cell);
                                        this.setState({ idForDeletion: cell.row._original.id }, () => {
                                            this.setState({ deleteWindow: true });
                                        });
                                        console.log('Edit note CELL :::', cell)
                                        // this.setState({
                                        //     deleteItemId: cell.row._original.id_pogonska_masina_klijent
                                        // });
                                        // this.onDeleteClick();
                                    }}
                                >
                                    <Icons.DeleteOutline className={classes.actionIcon} fontSize="default" />
                                </IconButton>
                            </Tooltip2>
                        </div>
                    );
                }
            },

        ];

        return (
            <div
                styles={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                className="page"
            >


                {/* <div className="table-header">
                    <Button
                        onClick={() => this.handleClick()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Plus headerIcon" />
                    </Button>
                    <Button
                        onClick={() => this.onSearchClick()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-search headerIcon" />
                    </Button>
                    <Button
                        onClick={() => this.onExportClick()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-download headerIcon" />
                    </Button>
                    {this.state.selection.length > 0 ?
                        <Button
                            onClick={() => this.onDeleteClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Kanta headerIcon" />
                        </Button>
                        : null
                    }
                    {this.state.selection.length === 1 ?
                        <Button
                            onClick={() => this.onEditClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className=" icon-Izmeni1 headerIcon" />
                        </Button>
                        : null
                    }
                </div> */}
                {/* <CheckboxTable
                    data={this.props.noteReport}
                    ref={r => (this.checkboxTable = r)}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.noteReportPages}
                    loading={this.props.noteReportFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getNoteReport(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: theme.palette.primary.main,
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: theme.palette.primary.main,
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                /> */}
                {this.state.addNewNote && <AddNote add={this.state.addNewNote} handleClose={this.handleCloseAddNewNote} edit={false} />}
                {this.state.editWindow && <AddNote add={this.state.editWindow} handleClose={this.handleCloseEditWindow} edit={true} itemForEdit={this.state.itemForEdit} />}
                {this.state.previewWindow && <AddNote add={this.state.previewWindow} handleClose={this.handleClosePreviewWindow} preview={true} edit={true} itemForEdit={this.state.itemForPreview} />}
                {/* <DashboardDrawer onPieClick={this.onPieClick} onTableClick={this.onTableClick} /> */}
                {this.state.export && <Export
                    export={this.state.export}
                    onTextChange={({ title }) => {
                        this.setState({ docTitle: title });
                    }}
                    handleClose={this.onExportClick}
                    exportDoc={this.exportFunction} />
                }
                {this.state.deleteWindow && <Delete delete={this.state.deleteWindow} handleClose={this.handleCloseDeleteWindow} deleteItem={this.deleteOneNote} />}



                {/* ==================================== */}

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>

                    <div className={css.searchWrap}>
                        <SearchBar
                            className={css.searchBar}
                            placeholder={i18n.t('Search by name')}
                            cancelOnEscape={true}
                            value={this.state.searchBarValue}
                            onChange={(searchValue) => this.setState({ searchBarValue: searchValue })}
                            onCancelSearch={() => this.setState({ searchBarValue: "" })}
                        />

                        <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            className={css.addNewBtn}
                            onClick={() => this.setState({ addNewNote: true })}
                        >
                            <AddIcon />
                            {i18n.t('Add new note')}
                        </Button>

                        {/* <Button
                                            variant="fab"
                                            color="primary"
                                            aria-label="Add"
                                            className={css.addNewBtn}
                                            onClick={() => { this.handleOpenNewMachine() }}
                                        >
                                            <AddIcon />
                                            {i18n.t('Add machines')}
                                        </Button> */}
                    </div>

                    <div className={css.filtersSection}>
                        <select className={css.dropDowns} value={this.state.selectedNoteType} onChange={(e) => this.setState({ selectedNoteType: e.target.value })} name="noteType" id="noteType">
                            <option value="">{i18n.t('Note type')}</option>
                            {this.state.allNoteTypes && this.state.allNoteTypes.map((noteType, i) => (
                                <option key={i} value={noteType.naziv_en}>{noteType.naziv}</option>
                            ))}
                        </select>

                        <label style={{ fontSize: '14px', marginRight: '20px', cursor: 'pointer' }} htmlFor="numberInput">{i18n.t('Field')}:</label>
                        <input value={this.state.selectedField} onChange={(e) => this.setState({ selectedField: e.target.value })} type="text" name='numberInput' id='numberInput' className={classes.numberInput} />

                        {/* <button className={classes.resetButton} onClick={this.resetMyFilters}>Resetuj filtere</button> {i18n.t("Total area of filtered parcels: ")}{this.state.totalArea} */}

                        <button className={css.resetButton} onClick={this.resetMyFilters}>{i18n.t('Reset filters')}</button>

                    </div>
                    {/* <div className={css.filtersSection}>
                        <select className={css.dropDowns} value={this.state.selectedModel} onChange={this.handleChangeModel} >
                                            <option value="">{i18n.t('Model')}</option>
                                            {this.state.models && this.state.models.map((model, i) => (
                                                <option key={i} value={model.id}>{model.value}</option>
                                            ))}
                                        </select>
                        <select className={css.dropDowns} value={this.state.selectedGroup} onChange={this.handleChangeGroup} >
                            <option value="">{i18n.t('Machines group')}</option>
                            {this.state.groups && this.state.groups.map((group, i) => (
                                <option key={i} value={group.id}>{group.value}</option>
                            ))}
                        </select>
                        <select className={css.dropDowns} value={this.state.selectedSubGroup} onChange={this.handleChangeSubGroup} disabled={this.state.selectedGroup === ""} >
                            <option value="">{i18n.t('Machines subgroup')}</option>
                            {this.state.subgroups && this.state.subgroups.map((subgroup, i) => (
                                <option key={i} value={subgroup.id}>{subgroup.value}</option>
                            ))}
                        </select>
                    </div> */}
                    <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflowX: 'auto', overflowY: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', minHeight: '550px' }}>

                        <ReactTable
                            className={css.compactTable}
                            ref={r => (this.reactTable = r)}
                            data={this.state.filteredNotes}
                            columns={columns2}
                            sortable={false}
                            filterable={false}
                            defaultPageSize={10}
                            showPaginationBottom={true}
                            previousText={'<'}
                            nextText={'>'}
                            pageText={''}
                            ofText={i18n.t('of')}
                            showPageSizeOptions={false}
                            rowsText={''}
                            style={{ display: 'flex', flexDirection: 'column', height: '650px' }}
                            PreviousComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            NextComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            getTrProps={(state, rowInfo) => {
                                if (!rowInfo) return {};
                                const owned = !!rowInfo.original.id_pogonska_masina_klijent;
                                const rowClass = owned ? css.clientRow : '';
                                return {
                                    className: rowClass,
                                    style: {
                                        minWidth: '1200px',
                                        textAlign: 'center',
                                        paddingLeft: '10px',
                                        height: '50px',
                                        alignItems: 'center',
                                        overflowY: 'hidden',
                                        overflowX: 'hidden',
                                    }
                                };
                            }}

                            LoadingComponent={() => (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <PulseLoader loading={this.state.loading} />
                                </div>
                            )}

                            NoDataComponent={() => (
                                <div style={{
                                    textAlign: 'center', padding: '20px', display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flex: 1
                                }}>
                                    {!this.state.filteredNotes && <span>{i18n.t('No rows found')}</span>}
                                </div>
                            )}
                        />
                    </div>
                </div>
            </div>
        )
    }
};

function mapStateToProps(state) {
    return {
        noteReport: state.noteReducer.noteReport,
        noteReportFetching: state.noteReducer.noteReportFetching,
        noteReportPages: state.noteReducer.noteReportPages,
        noteGroupDropDown: state.noteReducer.noteGroupDropDown,
        noteGroupDropDownFetching: state.noteReducer.noteGroupDropDownFetching,
        noteGroupDropDownFetchingFailed: state.noteReducer.noteGroupDropDownFetchingFailed,
        notesPostingSuccess: state.noteReducer.notesPostingSuccess,
        userProfile: state.appReducer.userProfile,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getNoteReport: (state, instance) => dispatch(getNoteReport(state, instance)),
        getNoteGroupDropDown: () => dispatch(getNoteGroupDropDown()),
        exportDocument: (title, state, url) => dispatch(exportDocument(title, state, url)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        getFieldNoteById: (id) => dispatch(getFieldNoteById(id)),
        getNoteDocument: (id) => dispatch(getNoteDocument(id)),
        deleteNote: (selection) => dispatch(deleteNote(selection)),
    }
}

export default withStyles(styles, { withTheme: true })(connect(
    mapStateToProps,
    mapDispatchToProps
)(Note));